import React from 'react';
import { styled, tooltipClasses } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

const BaseTooltip = styled(({ className, ...props }) => (
	<Tooltip
		// eslint-disable-next-line react/jsx-props-no-spreading
		{...props}
		classes={{ popper: className }}
	/>
))(() => ({
	[`& .${tooltipClasses.tooltip}`]: {
		maxWidth: '440px',
		padding: '8px 16px',
		border: `1px solid ${colorPalette.dark3}`,
		borderRadius: '4px',

		backgroundColor: colorPalette.dark2,
		color: colorPalette.light2,

		fontSize: '14px',
		fontWeight: 400,
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: colorPalette.dark2,
	},
}));

export default BaseTooltip;
